/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddOutputCommandResult } from '../models/add-output-command-result';
import { apiMeetingsAddOutputPut } from '../fn/meetings/api-meetings-add-output-put';
import { ApiMeetingsAddOutputPut$Params } from '../fn/meetings/api-meetings-add-output-put';
import { apiMeetingsAddOutputPut$Plain } from '../fn/meetings/api-meetings-add-output-put-plain';
import { ApiMeetingsAddOutputPut$Plain$Params } from '../fn/meetings/api-meetings-add-output-put-plain';
import { apiMeetingsCreateMeetingPost } from '../fn/meetings/api-meetings-create-meeting-post';
import { ApiMeetingsCreateMeetingPost$Params } from '../fn/meetings/api-meetings-create-meeting-post';
import { apiMeetingsCreateMeetingPost$Plain } from '../fn/meetings/api-meetings-create-meeting-post-plain';
import { ApiMeetingsCreateMeetingPost$Plain$Params } from '../fn/meetings/api-meetings-create-meeting-post-plain';
import { apiMeetingsDeleteMeetingDelete } from '../fn/meetings/api-meetings-delete-meeting-delete';
import { ApiMeetingsDeleteMeetingDelete$Params } from '../fn/meetings/api-meetings-delete-meeting-delete';
import { apiMeetingsDeleteMeetingDelete$Plain } from '../fn/meetings/api-meetings-delete-meeting-delete-plain';
import { ApiMeetingsDeleteMeetingDelete$Plain$Params } from '../fn/meetings/api-meetings-delete-meeting-delete-plain';
import { apiMeetingsGetMeetingGet } from '../fn/meetings/api-meetings-get-meeting-get';
import { ApiMeetingsGetMeetingGet$Params } from '../fn/meetings/api-meetings-get-meeting-get';
import { apiMeetingsGetMeetingGet$Plain } from '../fn/meetings/api-meetings-get-meeting-get-plain';
import { ApiMeetingsGetMeetingGet$Plain$Params } from '../fn/meetings/api-meetings-get-meeting-get-plain';
import { apiMeetingsGetMeetingsGet } from '../fn/meetings/api-meetings-get-meetings-get';
import { ApiMeetingsGetMeetingsGet$Params } from '../fn/meetings/api-meetings-get-meetings-get';
import { apiMeetingsGetMeetingsGet$Plain } from '../fn/meetings/api-meetings-get-meetings-get-plain';
import { ApiMeetingsGetMeetingsGet$Plain$Params } from '../fn/meetings/api-meetings-get-meetings-get-plain';
import { apiMeetingsUpdateMeetingPut } from '../fn/meetings/api-meetings-update-meeting-put';
import { ApiMeetingsUpdateMeetingPut$Params } from '../fn/meetings/api-meetings-update-meeting-put';
import { apiMeetingsUpdateMeetingPut$Plain } from '../fn/meetings/api-meetings-update-meeting-put-plain';
import { ApiMeetingsUpdateMeetingPut$Plain$Params } from '../fn/meetings/api-meetings-update-meeting-put-plain';
import { apiMeetingsUpdateOutputPut } from '../fn/meetings/api-meetings-update-output-put';
import { ApiMeetingsUpdateOutputPut$Params } from '../fn/meetings/api-meetings-update-output-put';
import { apiMeetingsUpdateOutputPut$Plain } from '../fn/meetings/api-meetings-update-output-put-plain';
import { ApiMeetingsUpdateOutputPut$Plain$Params } from '../fn/meetings/api-meetings-update-output-put-plain';
import { CreateMeetingCommandResult } from '../models/create-meeting-command-result';
import { DeleteMeetingCommandResult } from '../models/delete-meeting-command-result';
import { GetMeetingQueryResult } from '../models/get-meeting-query-result';
import { GetMeetingsQueryResult } from '../models/get-meetings-query-result';
import { UpdateMeetingCommandResult } from '../models/update-meeting-command-result';
import { UpdateOutputCommandResult } from '../models/update-output-command-result';

@Injectable({ providedIn: 'root' })
export class MeetingsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMeetingsGetMeetingsGet()` */
  static readonly ApiMeetingsGetMeetingsGetPath = '/api/Meetings/GetMeetings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMeetingsGetMeetingsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMeetingsGetMeetingsGet$Plain$Response(params?: ApiMeetingsGetMeetingsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMeetingsQueryResult>> {
    return apiMeetingsGetMeetingsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMeetingsGetMeetingsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMeetingsGetMeetingsGet$Plain(params?: ApiMeetingsGetMeetingsGet$Plain$Params, context?: HttpContext): Observable<GetMeetingsQueryResult> {
    return this.apiMeetingsGetMeetingsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetMeetingsQueryResult>): GetMeetingsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMeetingsGetMeetingsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMeetingsGetMeetingsGet$Response(params?: ApiMeetingsGetMeetingsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMeetingsQueryResult>> {
    return apiMeetingsGetMeetingsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMeetingsGetMeetingsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMeetingsGetMeetingsGet(params?: ApiMeetingsGetMeetingsGet$Params, context?: HttpContext): Observable<GetMeetingsQueryResult> {
    return this.apiMeetingsGetMeetingsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetMeetingsQueryResult>): GetMeetingsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiMeetingsGetMeetingGet()` */
  static readonly ApiMeetingsGetMeetingGetPath = '/api/Meetings/GetMeeting';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMeetingsGetMeetingGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMeetingsGetMeetingGet$Plain$Response(params?: ApiMeetingsGetMeetingGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMeetingQueryResult>> {
    return apiMeetingsGetMeetingGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMeetingsGetMeetingGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMeetingsGetMeetingGet$Plain(params?: ApiMeetingsGetMeetingGet$Plain$Params, context?: HttpContext): Observable<GetMeetingQueryResult> {
    return this.apiMeetingsGetMeetingGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetMeetingQueryResult>): GetMeetingQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMeetingsGetMeetingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMeetingsGetMeetingGet$Response(params?: ApiMeetingsGetMeetingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMeetingQueryResult>> {
    return apiMeetingsGetMeetingGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMeetingsGetMeetingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMeetingsGetMeetingGet(params?: ApiMeetingsGetMeetingGet$Params, context?: HttpContext): Observable<GetMeetingQueryResult> {
    return this.apiMeetingsGetMeetingGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetMeetingQueryResult>): GetMeetingQueryResult => r.body)
    );
  }

  /** Path part for operation `apiMeetingsCreateMeetingPost()` */
  static readonly ApiMeetingsCreateMeetingPostPath = '/api/Meetings/CreateMeeting';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMeetingsCreateMeetingPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMeetingsCreateMeetingPost$Plain$Response(params?: ApiMeetingsCreateMeetingPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateMeetingCommandResult>> {
    return apiMeetingsCreateMeetingPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMeetingsCreateMeetingPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMeetingsCreateMeetingPost$Plain(params?: ApiMeetingsCreateMeetingPost$Plain$Params, context?: HttpContext): Observable<CreateMeetingCommandResult> {
    return this.apiMeetingsCreateMeetingPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateMeetingCommandResult>): CreateMeetingCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMeetingsCreateMeetingPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMeetingsCreateMeetingPost$Response(params?: ApiMeetingsCreateMeetingPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateMeetingCommandResult>> {
    return apiMeetingsCreateMeetingPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMeetingsCreateMeetingPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMeetingsCreateMeetingPost(params?: ApiMeetingsCreateMeetingPost$Params, context?: HttpContext): Observable<CreateMeetingCommandResult> {
    return this.apiMeetingsCreateMeetingPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateMeetingCommandResult>): CreateMeetingCommandResult => r.body)
    );
  }

  /** Path part for operation `apiMeetingsUpdateMeetingPut()` */
  static readonly ApiMeetingsUpdateMeetingPutPath = '/api/Meetings/UpdateMeeting';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMeetingsUpdateMeetingPut$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMeetingsUpdateMeetingPut$Plain$Response(params?: ApiMeetingsUpdateMeetingPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateMeetingCommandResult>> {
    return apiMeetingsUpdateMeetingPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMeetingsUpdateMeetingPut$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMeetingsUpdateMeetingPut$Plain(params?: ApiMeetingsUpdateMeetingPut$Plain$Params, context?: HttpContext): Observable<UpdateMeetingCommandResult> {
    return this.apiMeetingsUpdateMeetingPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateMeetingCommandResult>): UpdateMeetingCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMeetingsUpdateMeetingPut()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMeetingsUpdateMeetingPut$Response(params?: ApiMeetingsUpdateMeetingPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateMeetingCommandResult>> {
    return apiMeetingsUpdateMeetingPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMeetingsUpdateMeetingPut$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMeetingsUpdateMeetingPut(params?: ApiMeetingsUpdateMeetingPut$Params, context?: HttpContext): Observable<UpdateMeetingCommandResult> {
    return this.apiMeetingsUpdateMeetingPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateMeetingCommandResult>): UpdateMeetingCommandResult => r.body)
    );
  }

  /** Path part for operation `apiMeetingsUpdateOutputPut()` */
  static readonly ApiMeetingsUpdateOutputPutPath = '/api/Meetings/UpdateOutput';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMeetingsUpdateOutputPut$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMeetingsUpdateOutputPut$Plain$Response(params?: ApiMeetingsUpdateOutputPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateOutputCommandResult>> {
    return apiMeetingsUpdateOutputPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMeetingsUpdateOutputPut$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMeetingsUpdateOutputPut$Plain(params?: ApiMeetingsUpdateOutputPut$Plain$Params, context?: HttpContext): Observable<UpdateOutputCommandResult> {
    return this.apiMeetingsUpdateOutputPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateOutputCommandResult>): UpdateOutputCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMeetingsUpdateOutputPut()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMeetingsUpdateOutputPut$Response(params?: ApiMeetingsUpdateOutputPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateOutputCommandResult>> {
    return apiMeetingsUpdateOutputPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMeetingsUpdateOutputPut$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMeetingsUpdateOutputPut(params?: ApiMeetingsUpdateOutputPut$Params, context?: HttpContext): Observable<UpdateOutputCommandResult> {
    return this.apiMeetingsUpdateOutputPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateOutputCommandResult>): UpdateOutputCommandResult => r.body)
    );
  }

  /** Path part for operation `apiMeetingsDeleteMeetingDelete()` */
  static readonly ApiMeetingsDeleteMeetingDeletePath = '/api/Meetings/DeleteMeeting';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMeetingsDeleteMeetingDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMeetingsDeleteMeetingDelete$Plain$Response(params?: ApiMeetingsDeleteMeetingDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteMeetingCommandResult>> {
    return apiMeetingsDeleteMeetingDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMeetingsDeleteMeetingDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMeetingsDeleteMeetingDelete$Plain(params?: ApiMeetingsDeleteMeetingDelete$Plain$Params, context?: HttpContext): Observable<DeleteMeetingCommandResult> {
    return this.apiMeetingsDeleteMeetingDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteMeetingCommandResult>): DeleteMeetingCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMeetingsDeleteMeetingDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMeetingsDeleteMeetingDelete$Response(params?: ApiMeetingsDeleteMeetingDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteMeetingCommandResult>> {
    return apiMeetingsDeleteMeetingDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMeetingsDeleteMeetingDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMeetingsDeleteMeetingDelete(params?: ApiMeetingsDeleteMeetingDelete$Params, context?: HttpContext): Observable<DeleteMeetingCommandResult> {
    return this.apiMeetingsDeleteMeetingDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteMeetingCommandResult>): DeleteMeetingCommandResult => r.body)
    );
  }

  /** Path part for operation `apiMeetingsAddOutputPut()` */
  static readonly ApiMeetingsAddOutputPutPath = '/api/Meetings/AddOutput';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMeetingsAddOutputPut$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMeetingsAddOutputPut$Plain$Response(params?: ApiMeetingsAddOutputPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddOutputCommandResult>> {
    return apiMeetingsAddOutputPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMeetingsAddOutputPut$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMeetingsAddOutputPut$Plain(params?: ApiMeetingsAddOutputPut$Plain$Params, context?: HttpContext): Observable<AddOutputCommandResult> {
    return this.apiMeetingsAddOutputPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddOutputCommandResult>): AddOutputCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMeetingsAddOutputPut()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMeetingsAddOutputPut$Response(params?: ApiMeetingsAddOutputPut$Params, context?: HttpContext): Observable<StrictHttpResponse<AddOutputCommandResult>> {
    return apiMeetingsAddOutputPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMeetingsAddOutputPut$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiMeetingsAddOutputPut(params?: ApiMeetingsAddOutputPut$Params, context?: HttpContext): Observable<AddOutputCommandResult> {
    return this.apiMeetingsAddOutputPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddOutputCommandResult>): AddOutputCommandResult => r.body)
    );
  }

}
